import React from 'react'

import Media from '../Media'
import Panel from './Panel'
import { useClassroomDispatch, useClassroomState } from '../../hooks'
import Sidebar from '../Sidebar'
import { useClassroomEnv } from '@components/ClassroomEnv'
import { Classroom as ClassroomConstants } from '@constants'

const Main = () => {
  const { panels } = useClassroomState()
  const { env } = useClassroomEnv()
  const classroomDispatch = useClassroomDispatch()

  return (
    <div
      className={`classroom-components`}
      onClick={() => classroomDispatch({ type: 'close_invite_modal' })}
    >
      {panels.map((v, i) => {
        return (
          <React.Fragment key={v}>
            <Panel type={v} />
            {i < panels.length - 1 && <div className='gp-classroom-handler' />}
          </React.Fragment>
        )
      })}

      <Media />

      {env !== ClassroomConstants.ENV.PLAYGROUND && <Sidebar />}
    </div>
  )
}

export default Main
